import type { LogProviderInterface } from 'utils/logger/logProviderFactory';

// Some iOS WKWebView environments (in-app browsers / injected scripts) monkey-patch
// console methods to forward logs to a native handler via
// window.webkit.messageHandlers.logging.postMessage. When that handler is missing,
// the patched console method itself throws, so every console call is wrapped to keep
// a broken console from throwing into application code. The catch swallows silently —
// there is nothing safe to log with if console itself is broken.

/**
 * Log generic messages here
 * @param {*} message
 */
const logMessage = (message: string) => {
    try {
        console.log(message);
    } catch {
        // noop
    }
};

/**
 * Log warning messages here
 * @param {*} message
 */
const logWarning = (message: string) => {
    try {
        console.warn(message);
    } catch {
        // noop
    }
};

const logError = (error: Error | string | unknown) => {
    try {
        console.error(error);
    } catch {
        // noop
    }
};

export default {
    logMessage,
    logError,
    logWarning,
} as LogProviderInterface;
